/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ChronometerIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M11,0.5 L13,0.5" />
      <path d="M12,0.5 L12,3.5" />
      <path d="M20,3.5 L21.5,5" />
      <path d="M20.75,4.25 L18.816,6.184" />
      <path d="M7,8.5 L8.5,10" />
      <path d="M12,20.5 L12,18.5" />
      <path d="M7,18.5 L8.5,17" />
      <path d="M19,13.5 L17,13.5" />
      <path d="M17,18.5 L15.5,17" />
      <path d="M17,8.5 L15.5,10" />
      <path d="M12,3.5 L12,13.5 L2,13.5 C2,19 6.477,23.5 12,23.5 C17.522,23.5 22,19.023 22,13.5 C22,7.978 17.522,3.5 12,3.5 Z" />
    </g>
  </svg>
);

export default ChronometerIcon;
